import { render, staticRenderFns } from "./CheatsheetLayer.vue?vue&type=template&id=4bc5f4b3&scoped=true"
import script from "./CheatsheetLayer.vue?vue&type=script&lang=js"
export * from "./CheatsheetLayer.vue?vue&type=script&lang=js"
import style0 from "./CheatsheetLayer.vue?vue&type=style&index=0&id=4bc5f4b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc5f4b3",
  null
  
)

export default component.exports